import { env } from 'env';

const PATH_PREFIX = env.REACT_APP_PATH_PREFIX;

export const Routing = {
    LogIn: `${PATH_PREFIX}/login`,
    SignUp: `${PATH_PREFIX}/sign-up`,
    TimeLine: `${PATH_PREFIX}/timeline`,
    Innerpage: `${PATH_PREFIX}/inner-page`,
    clinicalSummary: `${PATH_PREFIX}/clinical-summary`,
    Appointment: `${PATH_PREFIX}/appointment`,
    Questionnaire: `${PATH_PREFIX}/questionnaire`,
    PatientForms: `${PATH_PREFIX}/patient-forms`,
    D3Graph: `${PATH_PREFIX}/d3-graph`,
    Message: `${PATH_PREFIX}/message`,
    Labs: `${PATH_PREFIX}/labs`,
    // Images: `${PATH_PREFIX}/images`,
    Vitals: `${PATH_PREFIX}/vitals`,
    Diet: `${PATH_PREFIX}/diet`,
    Insurance: `${PATH_PREFIX}/insurance`,
    Allergy: `${PATH_PREFIX}/allergies`,
    Medication: `${PATH_PREFIX}/medication`,
    Procedure: `${PATH_PREFIX}/procedure`,
    Provider: `${PATH_PREFIX}/provider`,
    Problem: `${PATH_PREFIX}/problem`,
    ForgotPassword: `${PATH_PREFIX}/forgot-password`,
    ResetPassword: `${PATH_PREFIX}/reset-password`,
    Pharmacy: `${PATH_PREFIX}/pharmacy`,
    Billing: `${PATH_PREFIX}/billing`,
    Immunizations: `${PATH_PREFIX}/immunizations`,
    UrgentCare: `${PATH_PREFIX}/urgent-care`,
    VisitSummary: `${PATH_PREFIX}/visit-summary`,
    MyProfile: `${PATH_PREFIX}/my-profile`,
    EditPatient: `${PATH_PREFIX}/edit-patient`,
    Document: `${PATH_PREFIX}/document`,
    VideoSession: `${PATH_PREFIX}/video-session`,
    VideoSessionCall: `${PATH_PREFIX}/video-session/:urlRoomName`,
    Notification: `${PATH_PREFIX}/notification`,
    DocumentViewer: `${PATH_PREFIX}/document-viewer`,
    SMSQuestionnaire: `${PATH_PREFIX}/fill-questionnaire`,
    SMSPatientForm: `${PATH_PREFIX}/fill-patient-form`,
    PatientDetails: `${PATH_PREFIX}/patient-details`,
    PatientBasicDetails: `${PATH_PREFIX}/patient-details/:uuid`,
    PatientFeedback: `${PATH_PREFIX}/patient-feedback`,
    Payment: `${PATH_PREFIX}/bill-payment`,
    PaymentByLink: `${PATH_PREFIX}/bill-payment`,
    PaymentError: `${PATH_PREFIX}/payment-error`,
    PaymentSuccess: `${PATH_PREFIX}/payment-success`,
    PaymentErrorLink: `${PATH_PREFIX}/payment-error-page`,
    PaymentSuccessLink: `${PATH_PREFIX}/payment-success-page`,
    MedicalRecords: `${PATH_PREFIX}/medical-records`,
    MembershipPlans: `${PATH_PREFIX}/membership-plans`,
    CarePlans: `${PATH_PREFIX}/care-plans`,
    SavedCards: `${PATH_PREFIX}/saved-cards`,
    Facilities: `${PATH_PREFIX}/facilities`,
};
